import { t } from 'i18next';
import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { api_getProductTabs } from '~/backend/api_calls';
import { convertImageUrl_S_to_F } from '~/backend/helper';
import ProductTab from './ProductTab';

const ProductTabs = () => {
	const [productTabs, setProductTabs] = useState([]);

	// Runs once after init rendering + if eurl changes
	useEffect(() => {
		api_getProductTabs()
			.then(json => {
				setProductTabs(json.items);
			})
			.catch(error => {
				console.log(error);
			});
	}, []);

	return (
		<>
			{productTabs
				.filter(x => x.product_tab_entries.length > 0)
				.map((item, index) => (
					<section
						key={index}
						className={item.rtl ? 'product-tabs righttoleft' : 'product-tabs'}
						style={item.img2 === '' ? { backgroundImage: 'none' } : { backgroundImage: 'url(' + convertImageUrl_S_to_F(item.img2) + ')' }}>
						<div className="content-wrapper">
							<div className="tabs-container">
								<ProductTab productTab={item}></ProductTab>
							</div>

							<div className="main-image-container">
								<div className="image-wrapper">
									<img src={item.img1} alt="main-image-category" />
									{item.nu && (
										<Link to={item.nu} className="viewall-button arrow-button">
											{t('see_all')}
										</Link>
									)}
								</div>
							</div>
						</div>
					</section>
				))}
		</>
	);
};

export default ProductTabs;
